module.exports = __webpack_public_path__ + "img/inform.81c5910.80ad93ea.png";